var _g, _path, _path2, _g2, _g3, _path3, _path4, _g4, _g5, _ellipse, _path5, _path6, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _ellipse2, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 57,
    viewBox: "0 0 54 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 48.0479L18.0438 23.0073L27.3443 22.9624C30.0023 22.9495 32.5483 24.0236 34.3918 25.9356L39.4313 31.1623C41.1706 32.9662 42.1459 35.3726 42.1541 37.8803L42.1875 48.0479Z",
    fill: "#FFA41C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 48.0479L18.0438 23.0073L27.3443 22.9624C30.0023 22.9495 32.5483 24.0236 34.3918 25.9356L39.4313 31.1623C41.1706 32.9662 42.1459 35.3726 42.1541 37.8803L42.1875 48.0479Z",
    fill: "url(#paint0_linear_17_1478)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_1478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 22,
    width: 25,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1876 48.0476L18.0439 23.0071L27.3444 22.9621C30.0024 22.9493 32.5484 24.0234 34.3918 25.9353L39.4313 31.1621C41.1706 32.9659 42.1459 35.3723 42.1542 37.8801L42.1876 48.0476Z",
    fill: "#FFA41C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1876 48.0476L18.0439 23.0071L27.3444 22.9621C30.0024 22.9493 32.5484 24.0234 34.3918 25.9353L39.4313 31.1621C41.1706 32.9659 42.1459 35.3723 42.1542 37.8801L42.1876 48.0476Z",
    fill: "url(#paint1_linear_17_1478)",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2746 48.4632L7.92822 14.3936L26.1604 29.0033L42.2638 45.0212L42.2746 48.4632Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2746 48.4632L7.92822 14.3936L26.1604 29.0033L42.2638 45.0212L42.2746 48.4632Z",
    fill: "url(#paint2_linear_17_1478)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.287 41.7713L7.88647 7.69214L26.1187 22.3019L42.1781 38.219L42.287 41.7713Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.287 41.7713L7.88647 7.69214L26.1187 22.3019L42.1781 38.219L42.287 41.7713Z",
    fill: "url(#paint3_linear_17_1478)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5213 35.4295L8.01996 1.39429L26.2522 16.004L42.4564 31.978L42.5213 35.4295Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5213 35.4295L8.01996 1.39429L26.2522 16.004L42.4564 31.978L42.5213 35.4295Z",
    fill: "url(#paint4_linear_17_1478)",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 35.4295L9.19214 10.3889L18.4927 10.344C21.1506 10.3311 23.6966 11.4052 25.5401 13.3172L30.5796 18.5439C32.3189 20.3478 33.2942 22.7542 33.3024 25.2619L33.3359 35.4295Z",
    fill: "#FFA41C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 35.4295L9.19214 10.3889L18.4927 10.344C21.1506 10.3311 23.6966 11.4052 25.5401 13.3172L30.5796 18.5439C32.3189 20.3478 33.2942 22.7542 33.3024 25.2619L33.3359 35.4295Z",
    fill: "url(#paint5_linear_17_1478)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17_1478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 25,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 35.429L9.19214 10.3884L18.4927 10.3435C21.1506 10.3306 23.6966 11.4047 25.5401 13.3167L30.5796 18.5434C32.3189 20.3473 33.2942 22.7537 33.3024 25.2614L33.3359 35.429Z",
    fill: "#FFA41C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 35.429L9.19214 10.3884L18.4927 10.3435C21.1506 10.3306 23.6966 11.4047 25.5401 13.3167L30.5796 18.5434C32.3189 20.3473 33.2942 22.7537 33.3024 25.2614L33.3359 35.429Z",
    fill: "url(#paint6_linear_17_1478)",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8006 23.4976L-12.5457 -10.5721L5.6865 4.03761L21.7899 20.0555L21.8006 23.4976Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8006 23.4976L-12.5457 -10.5721L5.6865 4.03761L21.7899 20.0555L21.8006 23.4976Z",
    fill: "url(#paint7_linear_17_1478)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8131 16.8055L-12.5875 -17.2737L5.64476 -2.66393L21.7042 13.2531L21.8131 16.8055Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8131 16.8055L-12.5875 -17.2737L5.64476 -2.66393L21.7042 13.2531L21.8131 16.8055Z",
    fill: "url(#paint8_linear_17_1478)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0478 10.4636L-12.4536 -23.5717L5.77861 -8.9619L21.9828 7.01203L22.0478 10.4636Z",
    fill: "#FFD657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0478 10.4636L-12.4536 -23.5717L5.77861 -8.9619L21.9828 7.01203L22.0478 10.4636Z",
    fill: "url(#paint9_linear_17_1478)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.222,
    cy: 22.6334,
    r: 15.9544,
    fill: "#FFA114"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.222,
    cy: 22.6334,
    r: 15.9544,
    fill: "url(#paint10_linear_17_1478)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5891,
    r: 15.9426,
    fill: "url(#paint11_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2219,
    cy: 22.5893,
    r: 15.9426,
    transform: "rotate(30 32.2219 22.5893)",
    fill: "url(#paint12_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.222,
    cy: 22.5891,
    r: 15.9426,
    transform: "rotate(60 32.222 22.5891)",
    fill: "url(#paint13_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5891,
    r: 15.9426,
    transform: "rotate(90 32.2218 22.5891)",
    fill: "url(#paint14_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2219,
    cy: 22.5886,
    r: 15.9426,
    transform: "rotate(120 32.2219 22.5886)",
    fill: "url(#paint15_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2219,
    cy: 22.5889,
    r: 15.9426,
    transform: "rotate(150 32.2219 22.5889)",
    fill: "url(#paint16_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5891,
    r: 15.9426,
    transform: "rotate(-180 32.2218 22.5891)",
    fill: "url(#paint17_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.222,
    cy: 22.5886,
    r: 15.9426,
    transform: "rotate(-150 32.222 22.5886)",
    fill: "url(#paint18_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2219,
    cy: 22.5886,
    r: 15.9426,
    transform: "rotate(-120 32.2219 22.5886)",
    fill: "url(#paint19_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5889,
    r: 15.9426,
    transform: "rotate(-90 32.2218 22.5889)",
    fill: "url(#paint20_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5887,
    r: 15.9426,
    transform: "rotate(-60 32.2218 22.5887)",
    fill: "url(#paint21_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2218,
    cy: 22.5888,
    r: 15.9426,
    transform: "rotate(-30 32.2218 22.5888)",
    fill: "url(#paint22_angular_17_1478)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2221,
    cy: 22.5728,
    rx: 12.7999,
    ry: 12.7393,
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7091 20.1178C23.5171 19.6698 23.3291 19.3578 23.1451 19.1818C22.9691 18.9978 22.7611 18.8898 22.5211 18.8578V18.6178C22.5531 18.6178 22.6331 18.6138 22.7611 18.6058C22.8811 18.5978 22.9691 18.5938 23.0251 18.5938C23.2331 18.5938 23.4451 18.6098 23.6611 18.6418C23.8851 18.6738 24.1011 18.7418 24.3091 18.8458C24.5171 18.9498 24.7131 19.1018 24.8971 19.3018C25.0891 19.5018 25.2571 19.7738 25.4011 20.1178L27.2971 24.6058L29.8291 18.7138H30.4411L26.9851 26.7538H26.5051L23.7091 20.1178ZM31.412 18.7138H32.972V25.0738C32.972 25.4338 33.02 25.7258 33.116 25.9498C33.22 26.1658 33.452 26.2738 33.812 26.2738H33.932V26.6338H32.492C32.284 26.6338 32.108 26.6098 31.964 26.5618C31.828 26.5138 31.716 26.4298 31.628 26.3098C31.548 26.1898 31.492 26.0298 31.46 25.8298C31.428 25.6298 31.412 25.3778 31.412 25.0738V18.7138ZM37.5885 19.1938C37.4925 19.1938 37.3965 19.1978 37.3005 19.2058C37.2045 19.2138 37.1205 19.2258 37.0485 19.2418C36.9605 19.2578 36.8805 19.2698 36.8085 19.2778V22.9498H37.5285C37.7285 22.9498 37.9245 22.9218 38.1165 22.8658C38.3165 22.8098 38.4925 22.7098 38.6445 22.5658C38.7965 22.4218 38.9165 22.2298 39.0045 21.9898C39.1005 21.7418 39.1485 21.4338 39.1485 21.0658C39.1485 20.6978 39.1005 20.3938 39.0045 20.1538C38.9165 19.9138 38.7965 19.7218 38.6445 19.5778C38.5005 19.4338 38.3365 19.3338 38.1525 19.2778C37.9685 19.2218 37.7805 19.1938 37.5885 19.1938ZM37.5885 18.7138C37.7645 18.7138 37.9685 18.7218 38.2005 18.7378C38.4325 18.7538 38.6685 18.7938 38.9085 18.8578C39.1485 18.9138 39.3805 18.9938 39.6045 19.0978C39.8365 19.2018 40.0445 19.3458 40.2285 19.5298C40.4125 19.7058 40.5565 19.9258 40.6605 20.1898C40.7725 20.4458 40.8285 20.7578 40.8285 21.1258C40.8285 21.4698 40.7725 21.7658 40.6605 22.0138C40.5565 22.2618 40.4165 22.4738 40.2405 22.6498C40.0645 22.8178 39.8685 22.9538 39.6525 23.0578C39.4365 23.1618 39.2205 23.2418 39.0045 23.2978C38.7965 23.3538 38.5965 23.3898 38.4045 23.4058C38.2205 23.4218 38.0685 23.4298 37.9485 23.4298H36.8085V26.6338H35.2485V20.2738C35.2485 19.9138 35.1965 19.6258 35.0925 19.4098C34.9965 19.1858 34.7685 19.0738 34.4085 19.0738H34.2885V18.7138H37.5885Z",
    fill: "#FFDB6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7091 20.1178C23.5171 19.6698 23.3291 19.3578 23.1451 19.1818C22.9691 18.9978 22.7611 18.8898 22.5211 18.8578V18.6178C22.5531 18.6178 22.6331 18.6138 22.7611 18.6058C22.8811 18.5978 22.9691 18.5938 23.0251 18.5938C23.2331 18.5938 23.4451 18.6098 23.6611 18.6418C23.8851 18.6738 24.1011 18.7418 24.3091 18.8458C24.5171 18.9498 24.7131 19.1018 24.8971 19.3018C25.0891 19.5018 25.2571 19.7738 25.4011 20.1178L27.2971 24.6058L29.8291 18.7138H30.4411L26.9851 26.7538H26.5051L23.7091 20.1178ZM31.412 18.7138H32.972V25.0738C32.972 25.4338 33.02 25.7258 33.116 25.9498C33.22 26.1658 33.452 26.2738 33.812 26.2738H33.932V26.6338H32.492C32.284 26.6338 32.108 26.6098 31.964 26.5618C31.828 26.5138 31.716 26.4298 31.628 26.3098C31.548 26.1898 31.492 26.0298 31.46 25.8298C31.428 25.6298 31.412 25.3778 31.412 25.0738V18.7138ZM37.5885 19.1938C37.4925 19.1938 37.3965 19.1978 37.3005 19.2058C37.2045 19.2138 37.1205 19.2258 37.0485 19.2418C36.9605 19.2578 36.8805 19.2698 36.8085 19.2778V22.9498H37.5285C37.7285 22.9498 37.9245 22.9218 38.1165 22.8658C38.3165 22.8098 38.4925 22.7098 38.6445 22.5658C38.7965 22.4218 38.9165 22.2298 39.0045 21.9898C39.1005 21.7418 39.1485 21.4338 39.1485 21.0658C39.1485 20.6978 39.1005 20.3938 39.0045 20.1538C38.9165 19.9138 38.7965 19.7218 38.6445 19.5778C38.5005 19.4338 38.3365 19.3338 38.1525 19.2778C37.9685 19.2218 37.7805 19.1938 37.5885 19.1938ZM37.5885 18.7138C37.7645 18.7138 37.9685 18.7218 38.2005 18.7378C38.4325 18.7538 38.6685 18.7938 38.9085 18.8578C39.1485 18.9138 39.3805 18.9938 39.6045 19.0978C39.8365 19.2018 40.0445 19.3458 40.2285 19.5298C40.4125 19.7058 40.5565 19.9258 40.6605 20.1898C40.7725 20.4458 40.8285 20.7578 40.8285 21.1258C40.8285 21.4698 40.7725 21.7658 40.6605 22.0138C40.5565 22.2618 40.4165 22.4738 40.2405 22.6498C40.0645 22.8178 39.8685 22.9538 39.6525 23.0578C39.4365 23.1618 39.2205 23.2418 39.0045 23.2978C38.7965 23.3538 38.5965 23.3898 38.4045 23.4058C38.2205 23.4218 38.0685 23.4298 37.9485 23.4298H36.8085V26.6338H35.2485V20.2738C35.2485 19.9138 35.1965 19.6258 35.0925 19.4098C34.9965 19.1858 34.7685 19.0738 34.4085 19.0738H34.2885V18.7138H37.5885Z",
    fill: "url(#paint23_linear_17_1478)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.7263,
    cy: 35.9659,
    r: 0.849286,
    transform: "rotate(15.3234 26.7263 35.9659)",
    fill: "#FFFBF0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 35.2437 36.0742)",
    fill: "#FFFBF0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.7941,
    cy: 31.4473,
    r: 0.849286,
    transform: "rotate(15.3234 20.7941 31.4473)",
    fill: "#FFFBF0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 42.0797 33.0935)",
    fill: "#FFFBF0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.7695,
    cy: 24.5799,
    r: 0.849286,
    transform: "rotate(15.3234 17.7695 24.5799)",
    fill: "#FFFBF0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 46.6487 27.1416)",
    fill: "#FFFBF0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.8743,
    cy: 17.3348,
    r: 0.849286,
    transform: "rotate(15.3234 18.8743 17.3348)",
    fill: "#FFFBF0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 47.2963 19.8411)",
    fill: "#FFFBF0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.32,
    cy: 11.2103,
    r: 0.849286,
    transform: "rotate(15.3234 23.32 11.2103)",
    fill: "#FFFBF0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 44.4324 12.8357)",
    fill: "#FFFBF0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 26.4119 15.0059)",
    fill: "#FFE9AF"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 26.4119 28.8369)",
    fill: "#FFE9AF"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 29.5186 15.0059)",
    fill: "#FFE9AF"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 29.5186 28.8369)",
    fill: "#FFE9AF"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 32.5517 15.0059)",
    fill: "#FFE9AF"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 32.5517 28.8369)",
    fill: "#FFE9AF"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 35.5849 15.0059)",
    fill: "#FFE9AF"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 35.5849 28.8369)",
    fill: "#FFE9AF"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 38.6181 15.0059)",
    fill: "#FFE9AF"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.545969,
    cy: 0.545969,
    r: 0.545969,
    transform: "matrix(-0.956775 0.29083 0.29083 0.956775 38.6181 28.8369)",
    fill: "#FFE9AF"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.2721,
    cy: 8.33479,
    r: 0.849286,
    transform: "rotate(15.3234 30.2721 8.33479)",
    fill: "#FFFBF0"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_17_1478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.849286,
    cy: 0.849286,
    r: 0.849286,
    transform: "matrix(-0.999618 0.0276466 0.0276466 0.999618 38.3619 8.39136)",
    fill: "#FFFBF0"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 32.2221,
    cy: 32.7802,
    rx: 7.46158,
    ry: 2.48719,
    fill: "#FFE8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2221 9.8335C25.1529 9.8335 19.4221 15.7 19.4221 22.9368C23.5203 17.7213 34.3778 10.4197 45.022 22.9368C45.022 15.7 39.2913 9.8335 32.2221 9.8335Z",
    fill: "#FFE8E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_1478",
    x: 15.3171,
    y: 21.7936,
    width: 29.5972,
    height: 30.5392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17_1478",
    x: 6.4654,
    y: 9.17515,
    width: 29.5972,
    height: 30.5392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_17_1478",
    x: 14.7094,
    y: 6.67896,
    width: 35.0252,
    height: 35.0252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.779069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.89535
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.433575 0 0 0 0 0.0120139 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_17_1478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_17_1478",
    x: 23.9292,
    y: 33.1688,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_17_1478",
    x: 31.6213,
    y: 34.1497,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_17_1478",
    x: 17.997,
    y: 28.6502,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_17_1478",
    x: 38.4573,
    y: 31.169,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_17_1478",
    x: 14.9724,
    y: 21.7828,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_17_1478",
    x: 43.0263,
    y: 25.2171,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_17_1478",
    x: 16.0771,
    y: 14.5377,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_17_1478",
    x: 43.6739,
    y: 17.9166,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_17_1478",
    x: 20.5228,
    y: 8.41317,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_17_1478",
    x: 40.81,
    y: 10.9112,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_17_1478",
    x: 23.5545,
    y: 13.1932,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_17_1478",
    x: 23.5545,
    y: 27.0243,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_17_1478",
    x: 26.6612,
    y: 13.1932,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_17_1478",
    x: 26.6612,
    y: 27.0243,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_17_1478",
    x: 29.6943,
    y: 13.1932,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_17_1478",
    x: 29.6943,
    y: 27.0243,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_17_1478",
    x: 32.7275,
    y: 13.1932,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_17_1478",
    x: 32.7275,
    y: 27.0243,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_17_1478",
    x: 35.7607,
    y: 13.1932,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_17_1478",
    x: 35.7607,
    y: 27.0243,
    width: 4.98763,
    height: 4.98763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_17_1478",
    x: 27.4749,
    y: 5.53768,
    width: 5.59432,
    height: 5.59432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_17_1478",
    x: 34.7395,
    y: 6.46688,
    width: 5.59389,
    height: 5.59383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973837
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.805 0 0 0 0 0.5125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_1478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_1478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_1478",
    x1: 30.0743,
    y1: 22.9492,
    x2: 43.6055,
    y2: 47.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_1478",
    x1: 30.0744,
    y1: 22.9489,
    x2: 43.6055,
    y2: 47.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17_1478",
    x1: 25.0322,
    y1: 14.3244,
    x2: 42.9906,
    y2: 48.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17_1478",
    x1: 24.9905,
    y1: 7.62298,
    x2: 42.9489,
    y2: 41.3628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17_1478",
    x1: 25.124,
    y1: 1.32513,
    x2: 43.0823,
    y2: 35.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17_1478",
    x1: 21.2227,
    y1: 10.3308,
    x2: 34.7538,
    y2: 34.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17_1478",
    x1: 21.2227,
    y1: 10.3303,
    x2: 34.7538,
    y2: 34.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17_1478",
    x1: 4.55828,
    y1: -10.6413,
    x2: 22.5167,
    y2: 23.0985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17_1478",
    x1: 4.51654,
    y1: -17.3428,
    x2: 22.4749,
    y2: 16.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17_1478",
    x1: 4.65039,
    y1: -23.6408,
    x2: 22.6088,
    y2: 10.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17_1478",
    x1: 32.222,
    y1: 6.67895,
    x2: 32.222,
    y2: 38.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5891) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2219 22.5893) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.222 22.5891) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5891) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2219 22.5886) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2219 22.5889) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5891) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.222 22.5886) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2219 22.5886) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5889) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5887) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_angular_17_1478",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2218 22.5888) rotate(90) scale(15.9426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9447",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363583,
    stopColor: "#FF9447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#FF9447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17_1478",
    x1: 32.7632,
    y1: 16.6338,
    x2: 32.7632,
    y2: 31.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FFA41C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FFA41C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.e41c516631c2c9fe590704ec867771d2.svg";
export { ForwardRef as ReactComponent };